var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternaltransferchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1111112 0 0 1.1111112 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3846154 0 0 1.3846154 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5416667 0 0 0.5416667 0 0)"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7L5 7L19 7zM20 17L5 17",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3L19.2929 6.29289C 19.6834 6.68342 19.6834 7.31658 19.2929 7.70711L19.2929 7.70711L16 11",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13L4.70711 16.2929C 4.31658 16.6834 4.31658 17.3166 4.70711 17.7071L4.70711 17.7071L8 21",
    stroke: "#0C0310",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "none"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternaltransferchange);
export default __webpack_public_path__ + "static/media/internaltransferchange.d153a20496c86e4fb411c5f1df7272ec.svg";
export { ForwardRef as ReactComponent };